import Vue from 'vue';
import Router from 'vue-router';
import Products from '../views/Products';
import Product from '../views/Product';
import Register from '../views/Register';
import Profile from '../views/Profile';
import store from './../store';
import ResetPassword from '../views/ResetPassword';
import Query from '../views/Query';
import notFound from '../components/sharable/errors/notFound';

import SuppliersIndex from '@/views/Suppliers/index';
import Suppliers from '@/views/Suppliers/Suppliers';
import Supplier from '@/views/Suppliers/Supplier';
// Offers
import Offers from '@/views/Offers';
// Auth
import Auth from '../views/Auth/Index';
import BuyerLogin from '../views/Auth/BuyerLogin';
import SupplierLogin from '../views/Auth/SupplierLogin';


Vue.use(Router)

let router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: () => ({ name: 'products' })
        },
        {
            path: '/products',
            name: 'products',
            component: Products
        },
        {
            path: '/products/:id',
            name: 'product',
            props: true,
            component: Product,
            meta: {
              requiresAuth: false,
            },

        },
        {
            path: '/profile',
            name: 'buyer',
            props: true,
            component: Profile,
	    meta: {
        	requiresAuth: true,
      	    },
        },
	{
		path: '/register',
		name: 'register',
		props: true,
		component: Register,
	},
        {
           path: '/login',
	name: 'Auth',
	component: Auth,
	children: [
		{
		path: '/',
          	name: 'buyer-login',
		component: BuyerLogin,
	        },
        	{
		path: 'supplier',
		name: 'supplier-login',
		props: true,
		component: SupplierLogin,
        	}
	      	]
        },
        {
           path: '/auth/reset-password',
           name: 'reset-password',
           props: true,
           component: ResetPassword,
        },
        {
           path: '/suppliers',
           name: 'suppliers',
           component: SuppliersIndex,
           children: [
           {
             path: '/',
             name: 'get-all-suppliers',
             component: Suppliers,
           },
           {
             path: ':id',
             name: 'get-one-supplier',
             props: true,
             component: Supplier,
           }
         ]

        },
         {
           path: '/query',
           name: 'query',
           props: true,
           component: Query,
         },
         {
           path: '/404',
           name: '404',
           props: true,
           component: notFound,
         },




        // {
        //     path: '/auth/:provider/callback',
        //     component: {
        //         template: '<div class="auth-component"></div>'
        //     }
        // }
        {
          path: '/auth/:provider/callback',
          // component: {
          //   template: '<div class="auth-component"></div>'
         // }
    },
    {
      path: '/offers',
      name: 'offers',
      props: true,
      component: Offers,
    },


    ],
});
router.beforeEach((to, from, next) => {
  if (to.matched.some((data) => data.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next();
      return;
    }
    next('/login');
  } else {
    next();
  }
});

export default router;

